import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Avatar, Button, Modal, Input, message, Spin } from 'antd';
import { UserOutlined, MessageOutlined } from '@ant-design/icons';
import { get, post, isAuthenticated, getUsername } from '../utils/api';
import './css/UserProfile.css';

const { TextArea } = Input;

const UserProfile = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if the user is trying to view their own profile
    const currentUserId = localStorage.getItem('userid');
    if (currentUserId && userId === currentUserId) {
      // Redirect to user homepage if viewing own profile
      navigate('/user-homepage');
      return;
    }
    
    fetchUserProfile();
  }, [userId, navigate]);

  const fetchUserProfile = async () => {
    try {
      const response = await get(`/api/messaging/users/search/?q=${userId}`);
      if (response && response.length > 0) {
        setUser(response[0]);
      } else {
        message.error('用户不存在');
      }
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch user profile:', error);
      message.error('获取用户信息失败');
      setLoading(false);
    }
  };

  const openConversation = () => {
    if (!isAuthenticated()) {
      message.warning('请先登录后再查看私信');
      navigate('/login');
      return;
    }
    
    navigate(`/messages/${userId}`);
  };

  if (loading) {
    return (
      <div className="user-profile-loading">
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="user-profile-not-found">
        <Card>
          <h2>用户不存在</h2>
          <p>无法找到该用户的信息</p>
          <Button type="primary" onClick={() => navigate(-1)}>返回</Button>
        </Card>
      </div>
    );
  }

  return (
    <div className="user-profile-container">
      <Card className="user-profile-card">
        <div className="user-profile-header">
          <Avatar 
            size={100} 
            src={user.profile_picture_url} 
            icon={!user.profile_picture_url && <UserOutlined />}
          />
          <div className="user-profile-info">
            <h1>{user.username}</h1>
            <div className="user-profile-actions">
              <Button 
                type="primary" 
                icon={<MessageOutlined />}
                onClick={openConversation}
              >
                私信
              </Button>
            </div>
          </div>
        </div>

        <div className="user-profile-details">
          {user.first_name && user.last_name && (
            <div className="profile-detail-item">
              <strong>姓名:</strong> {user.first_name} {user.last_name}
            </div>
          )}
          
          {user.bio && (
            <div className="profile-detail-item">
              <strong>个人简介:</strong> {user.bio}
            </div>
          )}
          
          {user.location && (
            <div className="profile-detail-item">
              <strong>位置:</strong> {user.location}
            </div>
          )}
          
          {user.gender && (
            <div className="profile-detail-item">
              <strong>性别:</strong> {user.gender === 'M' ? '男' : user.gender === 'F' ? '女' : '未设置'}
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default UserProfile;
